import _JSXStyle from "styled-jsx/style";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { sharedPropTypes } from '@dhis2/ui-constants';
import { StatusIcon } from '@dhis2-ui/status-icon';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { styles } from './text-area.styles.js';
export class TextArea extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "textareaRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "state", {
      height: 'auto'
    });
    _defineProperty(this, "textareaDimensions", {
      width: 0,
      height: 0
    });
    _defineProperty(this, "userHasResized", false);
    _defineProperty(this, "setTextareaDimensions", () => {
      const textarea = this.textareaRef.current;
      this.textareaDimensions = {
        width: textarea.clientWidth,
        height: textarea.clientHeight
      };
    });
    _defineProperty(this, "hasUserResized", () => {
      const {
        width: oldWidth,
        height: oldHeight
      } = this.textareaDimensions;
      this.setTextareaDimensions();
      const {
        width: newWidth,
        height: newHeight
      } = this.textareaDimensions;
      const userHasResized = newWidth !== oldWidth || newHeight !== oldHeight;
      if (userHasResized) {
        this.userHasResized = true;
        this.removeResizeListener();
      }
    });
    _defineProperty(this, "handleChange", e => {
      if (this.props.onChange) {
        this.props.onChange(this.createHandlerPayload(e), e);
      }
    });
    _defineProperty(this, "handleBlur", e => {
      if (this.props.onBlur) {
        this.props.onBlur(this.createHandlerPayload(e), e);
      }
    });
    _defineProperty(this, "handleFocus", e => {
      if (this.props.onFocus) {
        this.props.onFocus(this.createHandlerPayload(e), e);
      }
    });
    _defineProperty(this, "handleKeyDown", e => {
      if (this.props.onKeyDown) {
        this.props.onKeyDown(this.createHandlerPayload(e), e);
      }
    });
  }
  componentDidMount() {
    this.attachResizeListener();
    if (this.props.initialFocus) {
      this.textareaRef.current.focus();
    }
    if (this.shouldDoAutoGrow()) {
      this.setHeight();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.shouldDoAutoGrow() && this.props.value !== prevProps.value) {
      this.setHeight();
    }
  }
  attachResizeListener() {
    const textarea = this.textareaRef.current;
    textarea.addEventListener('mousedown', this.setTextareaDimensions);
    textarea.addEventListener('mouseup', this.hasUserResized);
  }
  removeResizeListener() {
    const textarea = this.textareaRef.current;
    textarea.removeEventListener('mousedown', this.setTextareaDimensions);
    textarea.removeEventListener('mouseup', this.hasUserResized);
  }
  setHeight() {
    const textarea = this.textareaRef.current;
    const offset = textarea.offsetHeight - textarea.clientHeight;
    const height = textarea.scrollHeight + offset + 'px';
    this.setState({
      height
    });
  }
  shouldDoAutoGrow() {
    return this.props.autoGrow && !this.userHasResized;
  }
  createHandlerPayload(e) {
    return {
      value: e.target.value,
      name: this.props.name
    };
  }
  render() {
    const {
      className,
      dense,
      disabled,
      readOnly,
      placeholder,
      name,
      valid,
      error,
      warning,
      loading,
      value,
      tabIndex,
      resize = 'vertical',
      rows = 4,
      width = '100%',
      dataTest = 'dhis2-uicore-textarea'
    } = this.props;
    const {
      height
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      "data-test": dataTest,
      className: `jsx-${styles.__hash}` + " " + _JSXStyle.dynamic([["3036048772", [width, height, resize]]]) + " " + (cx('textarea', className) || "")
    }, /*#__PURE__*/React.createElement("textarea", {
      id: name,
      name: name,
      placeholder: placeholder,
      ref: this.textareaRef,
      value: value,
      disabled: disabled,
      readOnly: readOnly,
      tabIndex: tabIndex,
      onFocus: this.handleFocus,
      onKeyDown: this.handleKeyDown,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      rows: rows,
      className: `jsx-${styles.__hash}` + " " + _JSXStyle.dynamic([["3036048772", [width, height, resize]]]) + " " + (cx({
        dense,
        disabled,
        error,
        valid,
        warning,
        'read-only': readOnly
      }) || "")
    }), /*#__PURE__*/React.createElement(StatusIcon, {
      error: error,
      valid: valid,
      loading: loading,
      warning: warning
    }), /*#__PURE__*/React.createElement(_JSXStyle, {
      id: styles.__hash
    }, styles), /*#__PURE__*/React.createElement(_JSXStyle, {
      id: "3036048772",
      dynamic: [width, height, resize]
    }, [`textarea.__jsx-style-dynamic-selector{width:${width};height:${height};resize:${resize};}`]));
  }
}
_defineProperty(TextArea, "defaultProps", {
  rows: 4,
  width: '100%',
  resize: 'vertical',
  dataTest: 'dhis2-uicore-textarea'
});
TextArea.propTypes = {
  /** Grow the text area in response to overflow instead of adding a scroll bar */
  autoGrow: PropTypes.bool,
  className: PropTypes.string,
  dataTest: PropTypes.string,
  /** Compact mode */
  dense: PropTypes.bool,
  /** Disables the textarea and makes in non-interactive */
  disabled: PropTypes.bool,
  /** Applies 'error' styles for validation feedback. Mutually exclusive with `valid` and `warning` props */
  error: sharedPropTypes.statusPropType,
  /** Grabs initial focus on the page */
  initialFocus: PropTypes.bool,
  /** Adds a loading spinner */
  loading: PropTypes.bool,
  /** Name associated with the text area. Passed in object argument to event handlers. */
  name: PropTypes.string,
  /** Placeholder text for an empty textarea */
  placeholder: PropTypes.string,
  /** Makes the textarea read-only */
  readOnly: PropTypes.bool,
  /** [Resize property](https://developer.mozilla.org/en-US/docs/Web/CSS/resize) for the textarea element */
  resize: PropTypes.oneOf(['none', 'both', 'horizontal', 'vertical']),
  /** Initial height of the textarea, in lines of text */
  rows: PropTypes.number,
  tabIndex: PropTypes.string,
  /** Applies 'valid' styles for validation feedback. Mutually exclusive with `warning` and `error` props */
  valid: sharedPropTypes.statusPropType,
  /** Value in the textarea. Can be used to control component (recommended). Passed in object argument to event handlers. */
  value: PropTypes.string,
  /** Applies 'warning' styles for validation feedback. Mutually exclusive with `valid` and `error` props */
  warning: sharedPropTypes.statusPropType,
  /** Width of the text area. Can be any valid CSS measurement */
  width: PropTypes.string,
  /** Called with signature `({ name: string, value: string }, event)` */
  onBlur: PropTypes.func,
  /** Called with signature `({ name: string, value: string }, event)` */
  onChange: PropTypes.func,
  /** Called with signature `({ name: string, value: string }, event)` */
  onFocus: PropTypes.func,
  /** Called with signature `({ name: string, value: string }, event)` */
  onKeyDown: PropTypes.func
};